<template>
  <div class="step-container scrollPosition haus-step-6">
    <div class="step-header">
      <h2 class="step-title">Ausstattung</h2>
      <p class="step-text">Wie ist das Haus ausgestattet?</p>
    </div>
    <div class="step-body">
      <div class="box-container">
        <ActionBox
          class="box-item small-icon-w-50"
          text="Luxuriös"
          @click="setAusstattung(80)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8521.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8521_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="Hochwertig"
          @click="setAusstattung(70)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8555.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8555_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="Normal"
          @click="setAusstattung(50)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8011.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8011_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="Veraltet / einfach"
          @click="setAusstattung(40)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8009.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8009_white.svg')"
        />
      </div>
    </div>
    <div class="step-footer">
      <div class="row">
        <div class="col-md-4 col-sm-4 text-start">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionBox from "@/components/shared/ActionBox.vue";
import { saveToStorage } from "@/utils.js";
export default {
  name: "haus-step-7",
  components: {
    ActionBox,
  },
  data() {
    return {
      fields: {
        indexHausAusstattung: { value: null },
      },
    };
  },
  methods: {
    setAusstattung(index) {
      this.fields.indexHausAusstattung.value = index;
      saveToStorage(this.fields);
      this.$router.push("/haus-step-8a");
    },
    goBack() {
      this.$router.push("/haus-step-6");
    },
  },
  mounted() {
    this.$emit("setStep", "haus", 8);
  },
};
</script>
